import React, { useEffect } from 'react';

const Notification = ({ message, type = 'info', onDismiss }) => {
  const styles = {
    info:    { bar: 'bg-[#004AAD]',   bg: 'bg-white',        text: 'text-slate-700' },
    success: { bar: 'bg-emerald-500', bg: 'bg-white',        text: 'text-slate-700' },
    error:   { bar: 'bg-rose-500',    bg: 'bg-white',        text: 'text-slate-700' },
  };

  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => onDismiss(), 5000);
    return () => clearTimeout(timer);
  }, [message, onDismiss]);

  if (!message) return null;
  const s = styles[type] || styles.info;

  return (
    <div className={`fixed top-5 right-5 flex items-stretch rounded-xl shadow-sm border border-slate-200/80 overflow-hidden z-[100] max-w-sm ${s.bg}`}>
      <div className={`w-1 flex-shrink-0 ${s.bar}`} />
      <div className="flex items-center justify-between gap-4 px-4 py-3">
        <span className={`text-sm font-medium leading-snug ${s.text}`}>{message}</span>
        <button onClick={onDismiss} className="flex-shrink-0 text-slate-400 hover:text-slate-600 transition-colors text-lg font-bold leading-none">&times;</button>
      </div>
    </div>
  );
};

export default Notification;
